import { useAppStore, useTVStore } from '@/shared/store'
import { useAnalytics } from '@/app/context/AnalyticsContext/AnalyticsContext'
import { tvAssetType } from '@/shared/constants/appConstants'
import { ChannelDataType } from '@/shared/types/appTypes'

const useChannelChangeHook = () => {
    const {
        setWhatNextId,
        isPIPMode,
        setSelectedChannel,
        setDisplayNextButton,
        displayNextButton,
    } = useTVStore()
    const { setAssetType } = useAppStore()
    const Analytics = useAnalytics()

    const logChannelChangeToAnalytics = (channel: ChannelDataType) => {
        const currentDate: Date = new Date()
        const polishDate: string = currentDate.toLocaleString('pl-PL', {
            timeZone: 'Europe/Warsaw',
            hour12: false,
        })
        Analytics?.analyticsLogEvent('tune to a channel', {
            channel_name: channel.name,
            channel_id: channel.id,
            timestamp: polishDate,
        })
    }
    const handleChannelChange = (channel: ChannelDataType) => {
        if (isPIPMode && document.pictureInPictureElement)
            document.exitPictureInPicture()

        const { id } = channel
        if (id) setWhatNextId(id)
        logChannelChangeToAnalytics(channel)
        setAssetType(tvAssetType)
        setSelectedChannel(channel as ChannelDataType)

        if (displayNextButton) setDisplayNextButton(false)
    }
    return { handleChannelChange }
}

export default useChannelChangeHook
